import { useQuery } from '@tanstack/react-query';

import { usersQueryKey } from '@/api/queryKeys';
import { api } from '@/lib/api-client';
import { type UserDetail } from '@/models/user';

export const getUser = async (userId: number) => {
  const response = await api.get<UserDetail>(`/v1/users/${userId}`);
  return response.data;
};

/**
 * One user of the directory with every Grant they hold — across all Games, since
 * that is what the endpoint returns and what deciding whether a Grant is yours to
 * remove needs.
 *
 * A 404 (unknown user) and a 200 carrying `roles: []` (a real user holding
 * nothing) are deliberately distinct on the backend, so the caller must render
 * them differently: an error is not "this person has no access".
 *
 * ponytail: plain useQuery — the resource takes no game/sandbox scope, and the
 * Access area mounts above :sandboxCode where useAppQuery's SandboxProvider throws.
 */
export const useUser = (userId: number | null) =>
  useQuery({
    queryKey: usersQueryKey.detail(userId ?? 0),
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- `enabled` below is the null guard
    queryFn: () => getUser(userId!),
    enabled: userId !== null,
  });
